<template>
<div class="chapter">
<div class="inner_page">
<h1 class="part"><strong>The Beginning</strong></h1>
<div class="note5">
<p class="crt"><em>“I have always been willing to take the blame for the things I have done.”</em></p>
<p class="crt">—Lillie Langtry</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// p01.vue?5a4ab971